<template lang="pug">
multiselect.m-t-sm(
    track-by="id",
    label="name",
    :options="stocks",
    @select="onSelect",
    :selectLabel="selectLabel",
    :placeholder="placeholder",
    :internal-search="false",
    :loading="onLoading('fetch-inventories')",
    @search-change="searchInventories"
    :id="id"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }}
            small.clear.text-muted {{ props.option.sku }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import stockInventoryModule from '@js/store/modules/stock-inventory';

export default {
    props: {
        excludeIds: {
            type: Array,
            default: () => [],
        },

        selectLabel: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            default: '',
        },

        outletId: {
            type: Number,
            default: null,
        },

        page: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapGetters('stockInventory', ['stockInventoryList']),

        stocks() {
            if (this.excludeIds.length) {
                return this.stockInventoryList.filter(
                    stock => !this.excludeIds.includes(stock.stock_id),
                );
            }

            return this.stockInventoryList;
        },
    },

    watch: {
        outletId(outlet) {
            if (!_.isNull(outlet)) {
                this.setOutletId(outlet);
                this.getStockInventoryList();
            }
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stockInventory')) {
            this.$store.registerModule('stockInventory', stockInventoryModule);
        }
    },

    created() {
        if (this.outletId !== null) {
            this.setOutletId(this.outletId);

            if (!this.stockInventoryList.length) {
                this.getStockInventoryList();
            }
        }
    },

    mounted() {},

    methods: {
        ...mapActions('stockInventory', [
            'getStockInventoryList',
            'setOutletId',
        ]),

        onSelect(stock, id) {
            if (stock.quantity < 0 && this.page == 'stock_check') {
                let stock_name = stock.name;
                let stock_quantity = stock.quantity;

                this.swalWarning({
                    text: `${stock_name}
                    has negative quantity (${stock_quantity}). Please do the Stock Receive.`,
                });
            } else {
                this.$emit('select', stock, id);
            }
        },

        searchInventories: _.debounce(function(query) {
            this.getStockInventoryList({ query });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/stock-inventory-selector.vue